import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const RecoverPassword: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/auth/reset-password', { email: email.trim() });
      if (response.data.success) {
        setSent(true);
      } else {
        setError(response.data.error || 'Erro ao enviar email de recuperacao');
      }
    } catch (err: any) {
      setError(err.message || 'Erro ao processar pedido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-pagali-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-pagali-primary">PAGALI</h1>
          <p className="text-pagali-gray-500 mt-2">Recuperar Senha</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          {sent ? (
            <div className="text-center">
              <div className="text-5xl mb-4">📧</div>
              <h2 className="text-xl font-bold text-pagali-gray-900 mb-2">Email Enviado</h2>
              <p className="text-pagali-gray-600 mb-6">
                Enviamos um email para <strong>{email}</strong> com as instrucoes para recuperar a sua senha.
              </p>
              <p className="text-sm text-pagali-gray-400 mb-6">
                Verifique a sua caixa de entrada e a pasta de spam.
              </p>
              <Link
                to="/login"
                className="inline-block bg-pagali-primary text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90"
              >
                Voltar ao Login
              </Link>
            </div>
          ) : (
            <>
              <p className="text-pagali-gray-600 text-sm mb-6">
                Insira o seu email e enviaremos instrucoes para recuperar a sua senha.
              </p>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-4 text-sm">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-pagali-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu@email.cv"
                    required
                    className="w-full px-4 py-3 border border-pagali-gray-200 rounded-xl focus:ring-2 focus:ring-pagali-primary focus:border-transparent outline-none"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading || !email.trim()}
                  className="w-full bg-pagali-primary text-white py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'A enviar...' : 'Enviar Email de Recuperacao'}
                </button>
              </form>

              <div className="mt-6 text-center">
                <Link to="/login" className="text-sm text-pagali-primary hover:underline">
                  Voltar ao Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecoverPassword;
